import React, { useState } from 'react';
import { Activity, Plus } from 'lucide-react';
import ClinicalEventModal from './ClinicalEventModal';

interface ClinicalEventShortcutProps {
  patientId: string;
  clientId: string;
  patientName?: string;
  userId: string;
  userDisplayName?: string | null;
  onSaved?: () => void | Promise<void>;
  compact?: boolean;
  hideTrigger?: boolean;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
}

const ClinicalEventShortcut: React.FC<ClinicalEventShortcutProps> = ({
  patientId,
  clientId,
  patientName,
  userId,
  userDisplayName,
  onSaved,
  compact = false,
  hideTrigger = false,
  isOpen: controlledIsOpen,
  onOpenChange,
}) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const isOpen = controlledIsOpen ?? internalIsOpen;
  const setIsOpen = (nextIsOpen: boolean) => {
    if (controlledIsOpen === undefined) setInternalIsOpen(nextIsOpen);
    onOpenChange?.(nextIsOpen);
  };

  return (
    <>
      {!hideTrigger && (compact ? (
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-800 transition-colors hover:border-amber-300 hover:bg-amber-100"
          title="Registrar hospitalização, exacerbação, alta ou outra intercorrência na timeline do paciente"
        >
          <Activity className="h-3.5 w-3.5" />
          Evento clínico
        </button>
      ) : (
        <div className="flex min-h-16 w-full items-stretch rounded-xl border border-slate-200 bg-white transition-colors hover:border-amber-300">
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="flex min-w-0 flex-1 items-center rounded-l-xl px-3 py-2.5 text-left hover:bg-amber-50/50"
          >
            <span className="flex min-w-0 items-center gap-3">
              <span className="shrink-0 rounded-lg bg-amber-50 p-2 text-amber-700">
                <Activity className="h-4 w-4" />
              </span>
              <span className="min-w-0">
                <span className="block truncate text-sm font-semibold text-slate-900">Evento clínico</span>
                <span className="block truncate text-xs text-slate-500">Hospitalização, exacerbação, alta e outros</span>
              </span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="inline-flex shrink-0 items-center gap-1 border-l border-slate-200 px-3 text-xs font-semibold text-amber-800 hover:bg-amber-50"
          >
            <Plus className="h-4 w-4" /> Novo registro
          </button>
        </div>
      ))}

      <ClinicalEventModal
        isOpen={isOpen}
        patientId={patientId}
        clientId={clientId}
        patientName={patientName}
        userId={userId}
        userDisplayName={userDisplayName}
        onClose={() => setIsOpen(false)}
        onSaved={onSaved}
      />
    </>
  );
};

export default ClinicalEventShortcut;
